/*
	Creates a new search subscription
 */

const searchSubscriptions = document.querySelectorAll('.js__create_search_subscription');

if (searchSubscriptions) {
	searchSubscriptions.forEach((subBtn) => {
		subBtn.addEventListener('click', (el) => {
			el.preventDefault();

			$.post(el.target.dataset.url, {
				'__csrf_key': el.target.dataset.csrf,
				'redirect': el.target.dataset.redirect,
				'type': el.target.dataset.type,
				'searchQuery': el.target.dataset.queryjson,
				'process': el.target.dataset.process,
			})
				.always(() => {
					const redirect_to = new URL(window.location.origin);
					window.location.href = `${redirect_to}/subscriptions`;
				});
		});
	});
}
